/** A polyfill for the <details> element. Based on https://mathiasbynens.be/notes/html5-details-jquery. */
define(['jquery'],
function($) {

	// Test for browser support before doing anything else
	var nativeSupport = 'open' in document.createElement('details');
	if (!nativeSupport) {

		$(document.documentElement).addClass('no-details');

		$(document).on('click', 'summary', function() {
			var $summary = $(this);
			var $details = $summary.parents('details').first();
			var $content = $details.children().not($summary);

			var isOpen = !!$details.attr('open');
			if (isOpen) {
				$content.hide();
				$details.removeAttr('open');
			}
			else {
				$content.show();
				$details.attr('open', 'open');
			}
		});

	}

});
